import { useEffect } from "react";
import { Image } from "@fluentui/react-components";

// import { useCiTypeImageBlobUrlQuery } from "../hooks/useCiTypeQueries";
import { useFileIntoBlobUrl } from "../../files/hooks/useFileQueries";

export default function CiTypeImage({ ciType, url, ...imageProps }) {
  const { blobUrl: imageBlobUrl } = useFileIntoBlobUrl(
    ciType?.public_icon_id,
    !url && !!ciType?.public_id && !!ciType?.public_icon_id,
  );

  useEffect(() => {
    // Only revoke imageBlobUrl (fetched by this component), not url (managed by parent)
    if (imageBlobUrl) {
      return () => {
        URL.revokeObjectURL(imageBlobUrl);
      };
    }
  }, [imageBlobUrl]);

  if (!ciType) return null;

  return (
    <Image
      {...imageProps}
      alt={ciType?.name || "CiType Image"}
      src={url || imageBlobUrl ? url || imageBlobUrl : undefined}
    />
  );
}
